var map = {
	"./address.svg": "e8fc",
	"./alipay.svg": "e47f",
	"./arrow.svg": "21e2",
	"./diversification.svg": "cad5",
	"./email.svg": "43be",
	"./logo.svg": "5b1c",
	"./online.svg": "0599",
	"./postcode.svg": "54dd",
	"./stepOne.svg": "5bb5",
	"./stepThree.svg": "13be",
	"./stepTwo.svg": "41fe",
	"./systemPlatform.svg": "cb94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";